import React, {useState} from "react";
import CustomContainer from "../../components/CustomContainer";
import Loader from "../../components/Loader";
import CardTable from "../../components/table/CardTable";
import columns from "./config/VerificationTableConfig";
import { useTranslation } from 'react-i18next';
const VerificationPage = (props) => {

    const [loader, setLoader] = useState(false);
    const { t } = useTranslation();


    return (
        <>
            <Loader loader={loader}/>
            <CustomContainer title={t("verificationPage.verifications")}
                             className={"px-4"}>


                <CardTable
                    tittle={t("mainPage.verificationList")}
                    source={"verification"}
                    columns={columns(t)}
                    width={12}
                    setLoader={setLoader}
                    striped={false}
                    shadow={true}
                />
            </CustomContainer>
        </>
    );
};

export default VerificationPage;
